import { IReservation } from 'src/app/models/reservation.model';

export const INITIAL_RESERVATION: IReservation = {
  date: new Date(),
  reservationProgramId: 0,
  time: '',
  adults: 2,
  children: 0,
  infants: 0,
  note: '',
} as const;
